// /src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/app.css";

export function mount(App: React.ReactElement) {
  const el = document.getElementById("root");
  if (!el) throw new Error("Missing #root");
  ReactDOM.createRoot(el).render(
    <React.StrictMode>{App}</React.StrictMode>
  );
}
